import { render, staticRenderFns } from "./BtModelBuilder.vue?vue&type=template&id=a799c364&"
import script from "./BtModelBuilder.vue?vue&type=script&lang=js&"
export * from "./BtModelBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports